import { render, staticRenderFns } from "./BundleDetailHeader.vue?vue&type=template&id=2d101b52&"
import script from "./BundleDetailHeader.vue?vue&type=script&lang=js&"
export * from "./BundleDetailHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports